var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTableRow",
    {
      attrs: { expanded: _vm.row.subrowsVisible },
      on: {
        "update:expanded": function(expandValue) {
          _vm.$emit("update:subrowVisibility", expandValue)
        }
      }
    },
    [
      _vm._l(_vm.columns, function(column) {
        return _c(
          "CompassTableBodyCell",
          {
            key:
              "objectives-listing-table__table-row-" +
              _vm.row.id +
              "-column-" +
              column.code,
            attrs: {
              fixed: column.fixed,
              minWidth: column.width,
              alignContent: column.alignContent
            }
          },
          [
            column.code === "progress"
              ? [
                  _c(
                    "ProgressBarWithTooltip",
                    _vm._b(
                      {
                        staticClass:
                          "objectives-listing-table__table-progress-bar"
                      },
                      "ProgressBarWithTooltip",
                      _vm.row.progress,
                      false
                    )
                  )
                ]
              : column.code === "assignee"
              ? [
                  _c(
                    "AvatarListing",
                    _vm._b({}, "AvatarListing", _vm.row.assignee, false)
                  )
                ]
              : [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.row[column.code]) +
                      "\n        "
                  )
                ]
          ],
          2
        )
      }),
      _vm._v(" "),
      _c(
        "CompassTableBodyCell",
        { attrs: { fixed: "right", minWidth: "48px" } },
        [
          _vm.row.actions.length > 0
            ? _c(
                "CompassMenu",
                {
                  attrs: {
                    trigger: "hover",
                    placement: "left-start",
                    customClass: "objectives-listing-table__actions-container"
                  }
                },
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "action", size: "small" }
                  }),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "dropdown" },
                    _vm._l(_vm.row.actions, function(action, index) {
                      return _c(
                        "CompassMenuItem",
                        {
                          key:
                            "objectives-listing-table__table-row-" +
                            _vm.row.id +
                            "-action-" +
                            index,
                          attrs: { disabled: action.disabled },
                          on: { click: action.onClick }
                        },
                        [
                          _c(
                            "CompassTooltip",
                            {
                              attrs: {
                                disabled: !action.disabled,
                                content: action.tooltip
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(action.label) +
                                  "\n                    "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }